"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }

  return to;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectProvider = exports.SelectContext = void 0;

var react_1 = __importStar(require("react"));

var initialState = {
  isExpanded: false,
  setIsExpanded: function setIsExpanded() {},
  onChange: function onChange() {},
  selectedValue: '',
  menuId: '',
  registerOption: function registerOption() {},
  options: {
    current: []
  }
};
exports.SelectContext = react_1.createContext(initialState);

var SelectProvider = function SelectProvider(_a) {
  var onChange = _a.onChange,
      menuId = _a.menuId,
      selectedValue = _a.selectedValue,
      children = _a.children;

  var _b = react_1.useState(false),
      isExpanded = _b[0],
      setIsExpanded = _b[1];

  var options = react_1.useRef([]);

  var registerOption = function registerOption(value) {
    if (options.current.includes(value)) return;
    options.current = __spreadArray(__spreadArray([], options.current), [value]);
  };

  return react_1.default.createElement(exports.SelectContext.Provider, {
    value: {
      isExpanded: isExpanded,
      onChange: onChange,
      setIsExpanded: setIsExpanded,
      selectedValue: selectedValue,
      menuId: menuId,
      registerOption: registerOption,
      options: options
    }
  }, children);
};

exports.SelectProvider = SelectProvider;